import React, { useEffect, useMemo, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Grid,
  InputAdornment,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import { useStyles } from "../../../theme/appStyles";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import {
  useGetCategoryQuery,
  useGetPrinterQuery,
  useGetProductWithStoreQuery,
  useDeleteProductMutation,
  useGetBrandQuery,
  useGetProducHistroyRecordQuery,
  useGetProducStoreHistroyRecordQuery,
  useGetTagQuery,
  useGetStoreQuery,
  useGetMainItemQuery,
  useGetUserInfoOnyQuery,
  useGetProducOrderListRecodQuery,
  useGetAllAdminOrderListQuery,
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  IMainItem,
  IVariantView,
  IStore,
  IBrand,
  ITag,
  IPrinter,
  IProductPriceSplineChart,
  IUserAdmin,
  IOrderItemViewList2,
  IOrderList,
} from "../../../Api/Interface/api.interface";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import NewPopUpProduct from "../../Product/Edit/index";
import { useNotifier } from "../../../Core/Notifier";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { PRIORITY_COLORS, SizeOfLevelType } from "../../../Core/Enum/enum";
import StoreIcon from "@mui/icons-material/Store";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import ProductPriceChart from "./ProductPriceChart";
import { IoIosArrowRoundForward } from "react-icons/io";
import dayjs, { Dayjs } from "dayjs";
import StorepriceOnly from "../../Product/Edit/storepriceOnly";
import { IoIosImages } from "react-icons/io";
import useIsMobile from "../../../Core/hook/useIsMobile";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { FcRight } from "react-icons/fc";
import ReorderIcon from "@mui/icons-material/Reorder";
import Pagination from "../../../Components/Pagination";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import ReplaceImage from "../../../Images/repImg.png";

const convertUnit = (unit: number) => {
  switch (unit) {
    case SizeOfLevelType.kg:
      return "kg";
    case SizeOfLevelType.small:
      return "small";
    case SizeOfLevelType.li:
      return "li";
    case SizeOfLevelType.Medium:
      return "Medium";
    case SizeOfLevelType.Bottle:
      return "Bottle";
    case SizeOfLevelType.Each:
      return "Each";
    case SizeOfLevelType.Large:
      return "Large";
    case SizeOfLevelType.case:
      return "Case";
    case SizeOfLevelType.lb:
      return "lb";
    default:
      return "";
  }
};

const variantPropName = (unit: string) => {
  switch (unit) {
    case "variantName":
      return "Name";
    case "variantDisplayName":
      return "Display Name";
    case "categoryId":
      return "Category";
    case "cost":
      return "Cost";
    case "regularPrice":
      return "Regular Price";
    case "salePrice":
      return "Sale Price";
    case "variantShortDescription":
      return "Short Description";
    case "variantLongDescription":
      return "Long Description";
    case "variantUnit":
      return "Variant Unit";
    case "mainItemId":
      return "Product";
    case "packCount":
      return "Pack Count";
    case "categoryId":
      return "Category";
    case "size":
      return "Size";
    case "bgColor":
      return "Button Color";
    case "orderNumber":
      return "Order Number";
    case "isPosDisplay":
      return "Display";
    case "isOnSale":
      return "Sale";
    case "variantBrandId":
      return "Brand ";
    case "variantTagId":
      return "Tag";
    case "quantityKgOrLi":
      return "quantityKgOrLi";
    case "quantitySmallUnit":
      return "quantitySmallUnit";
    case "variantPrinterIds":
      return "Printers";
    case "isActive":
      return "Active";
    case "variantImg":
      return "Image";
    case "variantRefNumber":
      return "Reference Number";
    case "sizeUnit":
      return "Size Conversion unit";
    default:
      return "";
  }
};

const formatUnit = (value: number | string) => {
  const num = Number(value);
  return num % 1 === 0 ? num.toFixed(0) : num.toFixed(2);
};

enum Section {
  Price = "Price",
  History = "History",
  Order = "Order",
}

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { showErrorMessage, showMessage } = useNotifier();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const isMobileRes = useIsMobile();
  const [activeSection, setActiveSection] = useState<Section>(Section.Price);
  const handleContainerChange = (section: Section) => {
    setActiveSection(section);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<IVariantView | null>(
    null
  );
  const [openDialogProduct, setOpenDialogProduct] = useState(false);
  const [openDeleteProduct, setOpenDeleteProduct] = useState(false);
  const [productToDelete, setProductToDelete] = useState<IVariantView | null>(
    null
  );
  const [selectCustomer, setSelectCustomer] = useState<IMainItem | null>(null);
  const [selectedProduct2, setSelectedProduct2] = useState<IVariantView | null>(
    null
  );
  const [openDialogProduct2, setOpenDialogProduct2] = useState(false);
  const { id: ProductId } = useParams<{ id: string }>();

  useEffect(() => {}, [ProductId]);

  const { data, isLoading, isError } = useGetProductWithStoreQuery({
    searchText: "",
    id: String(ProductId),
    variantBrandId: null,
    categoryId: null,
    variantTagId: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
    mainItemId: null,
  });

  const { data: storeData, isLoading: storeIsLoading } = useGetStoreQuery({
    searchText: "",
    id: "",
  });

  const { data: productBrandData, isLoading: brandIsLoading } =
    useGetBrandQuery({
      searchText: "",
      isActive: "1",
      id: "",
    });
  const { data: productTagData, isLoading: ProductTagLoading } = useGetTagQuery(
    {
      searchText: "",
      isActive: "1",
      id: "",
    }
  );

  const { data: printerData, isLoading: PrinterLoading } = useGetPrinterQuery({
    searchText: "",
  });

  const { data: categoryData, isLoading: categoryLoading } =
    useGetCategoryQuery();

  const {
    data: productStoreHistoryRecordData,
    isLoading: storeRecordIsLoading,
  } = useGetProducStoreHistroyRecordQuery({
    productDetailsId: String(ProductId),
  });

  const {
    data: productHistoryRecordData,
    isLoading: productRecordIsLoading,
    isError: productIsError,
  } = useGetProducHistroyRecordQuery({
    productDetailsId: String(ProductId),
  });

  const {
    data: orderListRecordData,
    isLoading: orderListIsLoading,
    isError: orderListError,
  } = useGetProducOrderListRecodQuery({
    productId: String(ProductId),
  });

  const { data: maintItemData, isLoading: mainItemIsLoading } =
    useGetMainItemQuery({
      searchText: "",
      id: "",
      variantBrandId: null,
      categoryId: null,
      variantTagId: null,
      productViewOnline: null,
      createdDateStart: null,
      createdDateEnd: null,
      createdDate: null,
    });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const {
    data: SentToManagerData,
    isLoading: SentToManagerIsLoading,
    isError: SentToManagerIsError,
  } = useGetAllAdminOrderListQuery({
    searchText: "",
    orderListStatus: "",
    id: "",
  });

  const product = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as IVariantView;
    }
    return null;
  }, [data]);

  const getAllStoreList = useMemo(() => {
    return storeData?.data as IStore[];
  }, [storeData?.data]);

  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const productBrandList = useMemo(() => {
    return productBrandData?.data as IBrand[];
  }, [productBrandData?.data]);

  const productTagList = useMemo(() => {
    return productTagData?.data as ITag[];
  }, [productTagData?.data]);

  const printerList = useMemo(() => {
    return printerData?.data as IPrinter[];
  }, [printerData?.data]);

  const orderList = useMemo(() => {
    return SentToManagerData?.data as IOrderList[];
  }, [SentToManagerData?.data]);

  const productHistoryRecordList = useMemo(() => {
    return productStoreHistoryRecordData?.data as IProductPriceSplineChart[];
  }, [productStoreHistoryRecordData?.data]);

  const mainItemList = useMemo(() => {
    return maintItemData?.data as IMainItem[];
  }, [maintItemData?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const orderListMap = useMemo(() => {
    const map = new Map();
    orderList?.forEach((category) => {
      map.set(category.id, `${category.orderListId}`);
    });
    return map;
  }, [orderList]);

  const categoryMap = useMemo(() => {
    const map = new Map();
    categoryList?.forEach((category) => {
      map.set(category.id, toProperCase(category.categoryName));
    });
    return map;
  }, [categoryList]);

  const mainItenMap = useMemo(() => {
    const map = new Map();
    mainItemList?.forEach((category) => {
      map.set(category.id, toProperCase(category.mainItemName));
    });
    return map;
  }, [mainItemList]);

  const productBrandMap = useMemo(() => {
    const map = new Map();
    productBrandList?.forEach((brand) => {
      map.set(brand.id, toProperCase(brand.brandName));
    });
    return map;
  }, [productBrandList]);

  const tagMap = useMemo(() => {
    const map = new Map();
    productTagList?.forEach((brand) => {
      map.set(brand.id, brand.tagName);
    });
    return map;
  }, [productTagList]);

  const printerMap = useMemo(() => {
    const map = new Map();
    printerList?.forEach((brand) => {
      map.set(brand.id, toProperCase(brand.printerName));
    });
    return map;
  }, [printerList]);

  const getStoreMap = useMemo(() => {
    const map = new Map();
    getAllStoreList?.forEach((category) => {
      map.set(category.id, toProperCase(category.storeName));
    });
    return map;
  }, [getAllStoreList]);

  const handleOpenDialog = (product: IVariantView) => {
    setSelectedProduct(product);
    setOpenDialogProduct(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(null);
    setOpenDialogProduct(false);
  };

  const handleOpenDialog2 = (product: IVariantView) => {
    setSelectedProduct2(product);
    setOpenDialogProduct2(true);
  };

  const handleCloseDialog2 = () => {
    setSelectedProduct2(null);
    setOpenDialogProduct2(false);
  };

  const handleOpenDeletePopup = (product: IVariantView) => {
    setProductToDelete(product);
    setOpenDeleteProduct(true);
  };

  const handleCloseDeletePopup = () => {
    setProductToDelete(null);
    setOpenDeleteProduct(false);
  };

  const handleAddProductClick = () => {
    navigate(`/product/create/${product?.id}`);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const [deleteCategory] = useDeleteProductMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteProduct(false);
        navigate(`/main/item/view/${product?.mainItemId}`);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the product");
    }
  };

  const StatusCard = ({ label, value }: { label: string; value: boolean }) => (
    <Card
      sx={{
        padding: 2,
        height: "100%",
        border: `1px solid ${value ? "#4caf50" : "#f44336"}`,
        backgroundColor: value ? "#e8f5e9" : "#ffebee",
        borderRadius: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      }}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        wrap="nowrap"
      >
        <Typography variant="subtitle1" fontWeight={600}>
          {label}
        </Typography>
        {value ? (
          <CheckCircleOutlinedIcon sx={{ color: "#4caf50", fontSize: 36 }} />
        ) : (
          <HighlightOffOutlinedIcon sx={{ color: "#f44336", fontSize: 36 }} />
        )}
      </Grid>
    </Card>
  );

  const CompactStatusCard = ({
    label,
    status,
  }: {
    label: string;
    status: boolean;
  }) => {
    const iconColor = status ? "#4caf50" : "#f44336";
    const iconBg = status ? "#e8f5e9" : "#ffebee";
    const Icon = status ? CheckCircleIcon : CancelIcon;

    return (
      <Card className={classes.variantviewfristcard}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar sx={{ bgcolor: iconBg, color: iconColor }}>
            <Icon />
          </Avatar>
          <Typography variant="subtitle1" fontWeight={500}>
            {label}
          </Typography>
        </Stack>
      </Card>
    );
  };

  interface SelectCardProps {
    label: string;
    selecte: boolean;
    icon: React.ReactNode;
  }

  const SelectCard: React.FC<SelectCardProps> = ({ label, selecte, icon }) => {
    return (
      <Card
        className={
          selecte ? classes.selectedcardVariant : classes.unselectedcardVariant
        }
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar>{icon}</Avatar>
          <Typography variant="subtitle1" fontWeight={500}>
            {label}
          </Typography>
        </Stack>
      </Card>
    );
  };

  type DetailRowProps = {
    label: string;
    value: React.ReactNode;
  };
  const DetailRow: React.FC<DetailRowProps> = ({ label, value }) => (
    <Typography
      variant="subtitle1"
      sx={{
        display: "flex",
        borderBottom: "1px solid #e0e0e0",
        py: 0.8,
      }}
    >
      <Box
        component="span"
        sx={{
          width: "30%",
          fontWeight: 600,
          pr: 1,
        }}
      >
        {label}
      </Box>
      <Box
        component="span"
        sx={{
          width: "5%",
          fontWeight: 600,
          pr: 1,
        }}
      >
        {` : `}
      </Box>
      <Box
        component="span"
        sx={{
          width: "65%",
          pr: 1,
        }}
      >
        {value}
      </Box>
    </Typography>
  );

  if (
    isLoading ||
    categoryLoading ||
    storeIsLoading ||
    brandIsLoading ||
    ProductTagLoading ||
    PrinterLoading ||
    productRecordIsLoading ||
    mainItemIsLoading ||
    userIsLoading ||
    SentToManagerIsLoading ||
    orderListIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const renderContent = () => {
    switch (activeSection) {
      case Section.History:
        return (
          <div>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container justifyContent={"space-between"} spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.stepperCard}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={1}
                      sx={{ padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          alignContent: "center",
                        }}
                      >
                        <Typography
                          gutterBottom
                          className={classes.variantViewHedingeProg}
                        >
                          Variant History
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      height: "90vh",
                      overflow: "auto",
                      padding: "2px",
                      "&::-webkit-scrollbar": {
                        width: "4px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#eeeeee",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#eeeeee",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#eeeeee",
                      },
                    }}
                  >
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={2}
                      // sx={{ px: 2, pb: 3 }}
                      className={classes.titleGrid}
                    >
                      <>
                        {coursings.map((row: IVariantView, index) => {
                          const prevRow =
                            index > 0 ? coursings[index - 1] : null;

                          const areEqual = (a: any, b: any) => {
                            if (Array.isArray(a) && Array.isArray(b)) {
                              return (
                                a.length === b.length &&
                                a.every((val, i) => val === b[i])
                              );
                            }
                            return a === b;
                          };

                          const getChangedProperties = (
                            current: any,
                            previous: any
                          ) => {
                            if (!previous) return {};
                            const changedProps: Record<
                              string,
                              { oldValue: any; newValue: any }
                            > = {};

                            Object.keys(current).forEach((key) => {
                              if (key === "id") return;
                              if (!areEqual(current[key], previous[key])) {
                                changedProps[key] = {
                                  oldValue: previous[key],
                                  newValue: current[key],
                                };
                              }
                            });

                            return changedProps;
                          };

                          const changedProperties = getChangedProperties(
                            row,
                            prevRow
                          );

                          // ✅ Filter out changes with both old and new value as null/empty
                          const meaningfulChanges = Object.entries(
                            changedProperties
                          ).filter(([key, { oldValue, newValue }]) => {
                            if (key === "variant_created_at") return false;
                            if (key === "updated_by") return false;
                            if (key === "created_by") return false;

                            const isEmpty = (val: any) =>
                              val === null ||
                              val === undefined ||
                              val === "" ||
                              val === "null" ||
                              (Array.isArray(val) && val.length === 0);

                            return !(isEmpty(oldValue) && isEmpty(newValue));
                          });

                          const hasChanges = meaningfulChanges.length > 0;

                          if (!prevRow || !hasChanges) return null;

                          return (
                            <Grid item xs={12} key={row.id}>
                              <Card className={classes.stepperCardProductView}>
                                <CardContent>
                                  <Stack spacing={1} mb={2}>
                                    <Stack
                                      direction="row"
                                      alignItems="center"
                                      spacing={1}
                                    >
                                      <Typography variant="h6" fontWeight={600}>
                                        {dayjs(
                                          prevRow.variant_created_at
                                        ).format("MMM D, YYYY h:mm A")}
                                        {` | Updated by : ${userMap.get(
                                          prevRow.updated_by
                                        )}`}
                                      </Typography>
                                    </Stack>
                                  </Stack>

                                  <Divider sx={{ mb: 2 }} />

                                  {meaningfulChanges.map(
                                    ([key, { oldValue, newValue }]) => {
                                      let displayOld = String(oldValue);
                                      let displayNew = String(newValue);

                                      if (key === "variantBrandId") {
                                        displayOld =
                                          productBrandMap.get(oldValue) || "";
                                        displayNew =
                                          productBrandMap.get(newValue) || "";
                                      } else if (key === "variantTagId") {
                                        displayOld = Array.isArray(oldValue)
                                          ? oldValue
                                              .map(
                                                (id: any) =>
                                                  tagMap.get(id) || ""
                                              )
                                              .join(", ")
                                          : tagMap.get(oldValue) || "";
                                        displayNew = Array.isArray(newValue)
                                          ? newValue
                                              .map(
                                                (id: any) =>
                                                  tagMap.get(id) || ""
                                              )
                                              .join(", ")
                                          : tagMap.get(newValue) || "";
                                      } else if (key === "variantPrinterIds") {
                                        displayOld = Array.isArray(oldValue)
                                          ? oldValue
                                              .map(
                                                (id: any) =>
                                                  printerMap.get(id) || ""
                                              )
                                              .join(", ")
                                          : "";
                                        displayNew = Array.isArray(newValue)
                                          ? newValue
                                              .map(
                                                (id: any) =>
                                                  printerMap.get(id) || ""
                                              )
                                              .join(", ")
                                          : "";
                                      } else if (
                                        [
                                          "isActive",
                                          "isOnSale",
                                          "isPosDisplay",
                                        ].includes(key)
                                      ) {
                                        const formatBool = (val: any) =>
                                          String(val) === "1" || val === true
                                            ? "Yes"
                                            : "No";

                                        displayOld = formatBool(oldValue);
                                        displayNew = formatBool(newValue);
                                      } else if (key === "variantUnit") {
                                        displayOld =
                                          convertUnit(oldValue) || "";
                                        displayNew =
                                          convertUnit(newValue) || "";
                                      } else if (key === "sizeUnit") {
                                        displayOld =
                                          convertUnit(oldValue) || "";
                                        displayNew =
                                          convertUnit(newValue) || "";
                                      }

                                      return (
                                        <Stack spacing={2} mt={1}>
                                          {key === "bgColor" ? (
                                            <Box
                                              key={key}
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                mt: 1,
                                              }}
                                            >
                                              <Box
                                                component="span"
                                                sx={{
                                                  width: "30%",
                                                  fontWeight: 600,
                                                  pr: 1,
                                                }}
                                              >
                                                <Typography variant="subtitle1">
                                                  <strong>
                                                    {variantPropName(key)}
                                                  </strong>
                                                </Typography>
                                              </Box>
                                              <Box
                                                component="span"
                                                sx={{
                                                  width: "5%",
                                                  fontWeight: 600,
                                                  pr: 1,
                                                }}
                                              >
                                                {` : `}
                                              </Box>
                                              <Box
                                                component="span"
                                                sx={{
                                                  width: "65%",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 1,
                                                }}
                                              >
                                                {newValue &&
                                                  newValue !== "null" && (
                                                    <>
                                                      <Chip
                                                        // label="Old Button Color"
                                                        sx={{
                                                          backgroundColor:
                                                            newValue,
                                                          color: "#fff",
                                                          width: 24,
                                                          height: 24,
                                                        }}
                                                      />
                                                      <FcRight size={18} />
                                                    </>
                                                  )}

                                                {oldValue &&
                                                  oldValue !== "null" && (
                                                    <Chip
                                                      // label="New Button Color"
                                                      sx={{
                                                        backgroundColor:
                                                          oldValue,
                                                        color: "#fff",
                                                        width: 24,
                                                        height: 24,
                                                      }}
                                                    />
                                                  )}
                                              </Box>
                                            </Box>
                                          ) : key === "variantImg" ? (
                                            <Box
                                              key={key}
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 2,
                                                mt: 1,
                                              }}
                                            >
                                              <Box
                                                component="span"
                                                sx={{
                                                  width: "30%",
                                                  fontWeight: 600,
                                                  pr: 1,
                                                }}
                                              >
                                                <Typography variant="subtitle1">
                                                  <strong>
                                                    {variantPropName(key)}
                                                  </strong>
                                                </Typography>
                                              </Box>
                                              <Box
                                                component="span"
                                                sx={{
                                                  width: "5%",
                                                  fontWeight: 600,
                                                  pr: 1,
                                                }}
                                              >
                                                {` : `}
                                              </Box>
                                              <Box
                                                component="span"
                                                sx={{
                                                  width: "65%",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 1,
                                                }}
                                              >
                                                {newValue &&
                                                  newValue !== "null" && (
                                                    <>
                                                      <img
                                                        src={newValue}
                                                        alt="New"
                                                        style={{
                                                          width: 50,
                                                          height: 50,
                                                          objectFit: "cover",
                                                          borderRadius: 4,
                                                        }}
                                                      />
                                                      <FcRight size={18} />
                                                    </>
                                                  )}

                                                {oldValue &&
                                                  oldValue !== "null" && (
                                                    <img
                                                      src={oldValue}
                                                      alt="Old"
                                                      style={{
                                                        width: 50,
                                                        height: 50,
                                                        objectFit: "cover",
                                                        borderRadius: 4,
                                                      }}
                                                    />
                                                  )}
                                              </Box>
                                            </Box>
                                          ) : (
                                            <Typography
                                              key={key}
                                              variant="subtitle1"
                                              sx={{
                                                mt: 1,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                              }}
                                            >
                                              <Box
                                                component="span"
                                                sx={{
                                                  width: "30%",
                                                  fontWeight: 600,
                                                  pr: 1,
                                                }}
                                              >
                                                <strong>
                                                  {variantPropName(key)}
                                                </strong>
                                              </Box>
                                              <Box
                                                component="span"
                                                sx={{
                                                  width: "5%",
                                                  fontWeight: 600,
                                                  pr: 1,
                                                }}
                                              >
                                                {` : `}
                                              </Box>
                                              <Box
                                                component="span"
                                                sx={{
                                                  width: "65%",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 1,
                                                }}
                                              >
                                                {displayNew &&
                                                  displayNew !== "null" && (
                                                    <span>{displayNew}</span>
                                                  )}

                                                {displayNew &&
                                                  displayNew !== "null" &&
                                                  displayOld &&
                                                  displayOld !== "null" && (
                                                    <FcRight size={18} />
                                                  )}

                                                {displayOld &&
                                                  displayOld !== "null" && (
                                                    <span>{displayOld}</span>
                                                  )}
                                              </Box>
                                            </Typography>
                                          )}
                                        </Stack>
                                      );
                                    }
                                  )}
                                </CardContent>
                              </Card>
                            </Grid>
                          );
                        })}

                        {coursings.length > 0 && (
                          <Grid item xs={12}>
                            <Card className={classes.stepperCardProductView}>
                              <CardContent>
                                {(coursings[coursings.length - 1]
                                  .variant_created_at ||
                                  coursings[coursings.length - 1]
                                    .updated_by) && (
                                  <Stack spacing={1} mb={2}>
                                    <Stack
                                      direction="row"
                                      alignItems="center"
                                      spacing={1}
                                    >
                                      <Typography variant="h6" fontWeight={600}>
                                        {dayjs(
                                          coursings[coursings.length - 1]
                                            .variant_created_at
                                        ).format("YYYY-MM-D hh:mm A")}
                                        {` | Created by : ${userMap.get(
                                          coursings[coursings.length - 1]
                                            .created_by
                                        )}`}
                                      </Typography>
                                    </Stack>
                                  </Stack>
                                )}

                                <Divider sx={{ mt: 1, mb: 2 }} />

                                <Stack spacing={1} mt={1}>
                                  {Object.entries(
                                    coursings[coursings.length - 1]
                                  ).map(([key, value]) => {
                                    if (
                                      [
                                        "id",
                                        "variant_created_at",
                                        "updated_by",
                                        "created_by",
                                        "isLooping",
                                      ].includes(key)
                                    )
                                      return null;

                                    let displayValue = String(value);

                                    if (key === "variantBrandId") {
                                      displayValue =
                                        productBrandMap.get(value) || "";
                                    } else if (key === "variantTagId") {
                                      displayValue = Array.isArray(value)
                                        ? value
                                            .map(
                                              (id: any) => tagMap.get(id) || ""
                                            )
                                            .join(", ")
                                        : tagMap.get(value) || "";
                                    } else if (key === "variantPrinterIds") {
                                      displayValue = Array.isArray(value)
                                        ? value
                                            .map(
                                              (id: any) =>
                                                printerMap.get(id) || ""
                                            )
                                            .join(", ")
                                        : "";
                                    } else if (
                                      [
                                        "isActive",
                                        "isOnSale",
                                        "isPosDisplay",
                                      ].includes(key)
                                    ) {
                                      displayValue =
                                        String(value) === "1" || value === true
                                          ? "Yes"
                                          : "No";
                                    } else if (key === "mainItemId") {
                                      displayValue =
                                        mainItenMap.get(value) || "";
                                    } else if (key === "variantUnit") {
                                      displayValue = convertUnit(value) || "";
                                    } else if (key === "sizeUnit") {
                                      displayValue = convertUnit(value) || "";
                                    }

                                    const isEmpty =
                                      displayValue === "" ||
                                      displayValue === "null" ||
                                      displayValue === null;

                                    return !isEmpty ? (
                                      <Stack spacing={2} mt={1}>
                                        {key === "bgColor" ? (
                                          <Box
                                            key={key}
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 1,
                                              mt: 1,
                                            }}
                                          >
                                            <Box
                                              component="span"
                                              sx={{
                                                width: "30%",
                                                fontWeight: 600,
                                                pr: 1,
                                              }}
                                            >
                                              <Typography variant="subtitle1">
                                                <strong>
                                                  {variantPropName(key)}
                                                </strong>
                                              </Typography>
                                            </Box>
                                            <Box
                                              component="span"
                                              sx={{
                                                width: "5%",
                                                fontWeight: 600,
                                                pr: 1,
                                              }}
                                            >
                                              {` : `}
                                            </Box>
                                            <Box
                                              component="span"
                                              sx={{
                                                width: "65%",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                              }}
                                            >
                                              {displayValue &&
                                                displayValue !== "null" && (
                                                  <Chip
                                                    // label="New Button Color"
                                                    sx={{
                                                      backgroundColor:
                                                        displayValue,
                                                      color: "#fff",
                                                      width: 24,
                                                      height: 24,
                                                    }}
                                                  />
                                                )}
                                            </Box>
                                          </Box>
                                        ) : key === "variantImg" ? (
                                          <Box
                                            key={key}
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 2,
                                              mt: 1,
                                            }}
                                          >
                                            <Box
                                              component="span"
                                              sx={{
                                                width: "30%",
                                                fontWeight: 600,
                                                pr: 1,
                                              }}
                                            >
                                              <Typography variant="subtitle1">
                                                <strong>
                                                  {variantPropName(key)}
                                                </strong>
                                              </Typography>
                                            </Box>
                                            <Box
                                              component="span"
                                              sx={{
                                                width: "5%",
                                                fontWeight: 600,
                                                pr: 1,
                                              }}
                                            >
                                              {` : `}
                                            </Box>
                                            <Box
                                              component="span"
                                              sx={{
                                                width: "65%",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                              }}
                                            >
                                              {displayValue &&
                                                displayValue !== "null" && (
                                                  <img
                                                    src={displayValue}
                                                    alt="Old"
                                                    style={{
                                                      width: 50,
                                                      height: 50,
                                                      objectFit: "cover",
                                                      borderRadius: 4,
                                                    }}
                                                  />
                                                )}
                                            </Box>
                                          </Box>
                                        ) : (
                                          <Typography
                                            key={key}
                                            variant="subtitle1"
                                            sx={{
                                              mt: 1,
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 1,
                                            }}
                                          >
                                            <Box
                                              component="span"
                                              sx={{
                                                width: "30%",
                                                fontWeight: 600,
                                                pr: 1,
                                              }}
                                            >
                                              <strong>
                                                {variantPropName(key)}
                                              </strong>
                                            </Box>
                                            <Box
                                              component="span"
                                              sx={{
                                                width: "5%",
                                                fontWeight: 600,
                                                pr: 1,
                                              }}
                                            >
                                              {` : `}
                                            </Box>
                                            <Box
                                              component="span"
                                              sx={{
                                                width: "65%",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                              }}
                                            >
                                              {displayValue &&
                                                displayValue !== "null" && (
                                                  <span>{displayValue}</span>
                                                )}
                                            </Box>
                                          </Typography>
                                        )}
                                      </Stack>
                                    ) : null;
                                  })}
                                </Stack>
                              </CardContent>
                            </Card>
                          </Grid>
                        )}
                      </>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </div>
        );
      case Section.Order:
        return (
          <div>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container justifyContent={"space-between"} spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      height: "90vh",
                      overflow: "auto",
                      padding: "2px",
                      "&::-webkit-scrollbar": {
                        width: "4px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#eeeeee",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#eeeeee",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#eeeeee",
                      },
                    }}
                  >
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={2}
                      // sx={{ px: 2, pb: 3 }}
                      className={classes.titleGrid}
                    >
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Card className={classes.stepperCard}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={1}
                            sx={{
                              // borderBottom: 2,
                              padding: 2,
                            }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                alignContent: "center",
                              }}
                            >
                              <Typography
                                gutterBottom
                                className={classes.variantViewHedingeProg}
                              >
                                Order List History
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid>
                            <TableContainer>
                              <Table className={classes.table}>
                                <TableHead className={classes.tableHeaderRow}>
                                  <TableRow>
                                    <TableCell
                                      className={classes.tablheaderNoWidth}
                                      sx={{ width: "5%" }}
                                    >
                                      <strong>#</strong>
                                    </TableCell>
                                    <TableCell
                                      className={classes.tablheader}
                                      sx={{ width: "60%" }}
                                    >
                                      <strong>OrderList</strong>
                                    </TableCell>
                                    <TableCell className={classes.tablheader}>
                                      <strong>Store</strong>
                                    </TableCell>
                                    <TableCell className={classes.tablheader}>
                                      <strong>Qty</strong>
                                    </TableCell>
                                    {/* <TableCell className={classes.tablheader}>
                                      <strong>Priority</strong>
                                    </TableCell> */}
                                    <TableCell className={classes.tablheader}>
                                      <strong>Price</strong>
                                    </TableCell>
                                    <TableCell
                                      className={classes.tablheader}
                                      sx={{ textAlign: "right" }}
                                    >
                                      <strong>Actions</strong>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {productIsError || coursings.length === 0 ? (
                                    <TableRow>
                                      <TableCell colSpan={20} align="center">
                                        {orderListError
                                          ? "Error fetching data"
                                          : "No data available"}
                                      </TableCell>
                                    </TableRow>
                                  ) : (
                                    storeItemsList
                                      .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                      )
                                      .map(
                                        (row: IOrderItemViewList2, index) => (
                                          <TableRow
                                            key={row.id}
                                            className={classes.tableRowHover}
                                          >
                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                              // sx={{ textAlign: "center" }}
                                            >
                                              {index + 1}
                                            </TableCell>

                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                            >
                                              <Link
                                                to={`/order/list/set/price/list/${row.orderId}`}
                                                className={
                                                  classes.iconLinkPropNormal
                                                }
                                              >
                                                <Grid
                                                  container
                                                  spacing={1}
                                                  sx={{ cursor: "pointer" }}
                                                >
                                                  <Grid
                                                    item
                                                    textAlign={"center"}
                                                    alignContent={"center"}
                                                  >
                                                    <Typography
                                                      className={
                                                        classes.nameTableList
                                                      }
                                                    >
                                                      {orderListMap.get(
                                                        row.orderId
                                                      ) || ""}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </Link>
                                            </TableCell>
                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                            >
                                              <Link
                                                to={`/store/view/${row.storeId}`}
                                                className={
                                                  classes.iconLinkPropNormal
                                                }
                                              >
                                                <Typography>
                                                  {getStoreMap.get(
                                                    row.storeId
                                                  ) || ""}
                                                </Typography>
                                              </Link>
                                            </TableCell>
                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                            >
                                              <Typography>
                                                {row.productTotalUnit}{" "}
                                                {convertUnit(row.variantUnit)}
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                            >
                                              {row.productUnitPrice
                                                ? `$${row.productUnitPrice}`
                                                : ""}
                                            </TableCell>

                                            <TableCell
                                              className={classes.tablCell}
                                            >
                                              <Grid
                                                container
                                                spacing={1}
                                                sx={{
                                                  display: "flex",
                                                  justifyContent: "flex-end",
                                                }}
                                              >
                                                <Grid item>
                                                  <Link
                                                    to={`/order/list/set/price/list/${row.orderId}`}
                                                    className={
                                                      classes.iconLinkPropNormal
                                                    }
                                                  >
                                                    <Button
                                                      className={
                                                        classes.viewButtonList
                                                      }
                                                    >
                                                      <VisibilitySharpIcon
                                                        className={
                                                          classes.viewListIcon
                                                        }
                                                      />
                                                    </Button>
                                                  </Link>
                                                </Grid>
                                              </Grid>
                                            </TableCell>
                                          </TableRow>
                                        )
                                      )
                                  )}
                                </TableBody>
                              </Table>

                              <Grid
                                spacing={5}
                                p={"18px"}
                                py={4}
                                justifyContent={"end"}
                                container
                                textAlign={"center"}
                                alignContent={"center"}
                                alignItems={"center"}
                              >
                                <Grid
                                  sx={{
                                    textAlign: "end",
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end",
                                  }}
                                >
                                  <Pagination
                                    count={storeItemsList.length}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    onPageChange={handleChangePage}
                                  />
                                </Grid>
                              </Grid>
                            </TableContainer>
                          </Grid>
                        </Card>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </div>
        );
      case Section.Price:
        return (
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.stepperCard} sx={{ p: "24px" }}>
                <Grid container spacing={2}>
                  {(product?.cost ||
                    product?.regularPrice ||
                    product?.salePrice) && (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={2}
                      >
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography
                            gutterBottom
                            className={classes.variantViewHedingeProg}
                          >
                            Pricing Summary
                          </Typography>
                          <Stack spacing={1} px={2} py={1}>
                            {product?.cost && (
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <MonetizationOnIcon
                                  color="success"
                                  sx={{ mr: 1 }}
                                />
                                <Typography variant="body2">
                                  Cost: ${product.cost}
                                </Typography>
                              </Box>
                            )}
                            {product?.regularPrice && (
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <PriceChangeIcon
                                  color="primary"
                                  sx={{ mr: 1 }}
                                />
                                <Typography variant="body2">
                                  Regular: ${product.regularPrice}
                                </Typography>
                              </Box>
                            )}
                            {product?.salePrice && (
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <LocalOfferIcon color="error" sx={{ mr: 1 }} />
                                <Typography variant="body2">
                                  Sale: ${product.salePrice}
                                </Typography>
                              </Box>
                            )}
                          </Stack>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Card className={classes.stepperCard}>
                      <Typography
                        gutterBottom
                        className={classes.variantViewHedingeProg}
                      >
                        Supplier Pricing Summary
                      </Typography>

                      {product?.storeDetails &&
                      product.storeDetails.length > 0 ? (
                        <Grid container spacing={3}>
                          {product.storeDetails.map((store, index) => (
                            <Grid
                              item
                              key={index}
                              lg={4}
                              md={6}
                              sm={12}
                              xs={12}
                            >
                              <Paper
                                elevation={1}
                                sx={{
                                  p: 2.5,
                                  borderRadius: "4px",
                                  height: "100%",
                                  background:
                                    "linear-gradient(to bottom, #f9f9f9, #fff)",
                                  border: "1px solid #e0e0e0",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleOpenDialog2(product)}
                              >
                                <Stack spacing={1.5}>
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                  >
                                    <StoreIcon color="primary" />
                                    <Typography
                                      variant="subtitle1"
                                      fontWeight="bold"
                                    >
                                      {getStoreMap.get(store.storeId) ||
                                        "Unnamed Supplier"}
                                    </Typography>
                                  </Box>

                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                  >
                                    <MonetizationOnIcon color="success" />
                                    <Typography
                                      variant="body1"
                                      fontWeight="bold"
                                    >
                                      {store.price !== null
                                        ? `$${store.price}`
                                        : "N/A"}
                                    </Typography>
                                  </Box>

                                  {store.referenceNo && (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      gap={1}
                                    >
                                      <InfoOutlinedIcon color="info" />
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        Ref No: {store.referenceNo}
                                      </Typography>
                                    </Box>
                                  )}
                                </Stack>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          No pricing details available for any store.
                        </Typography>
                      )}
                    </Card>
                  </Grid>
                </Grid>
              </Card>
            </Grid>

            {productHistoryRecordList &&
              productHistoryRecordList.length > 0 && (
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.stepperCard} sx={{ p: "24px" }}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={2}
                    >
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={1}
                          sx={{ padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              alignContent: "center",
                            }}
                          >
                            <Typography
                              gutterBottom
                              className={classes.variantViewHedingeProg}
                            >
                              Price History
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ px: 2, pb: 3 }}
                          className={classes.titleGrid}
                        >
                          {productHistoryRecordList &&
                            productHistoryRecordList.length > 0 && (
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                width={"100%"}
                              >
                                {!storeRecordIsLoading && (
                                  <ProductPriceChart
                                    data={productHistoryRecordList}
                                  />
                                )}
                              </Grid>
                            )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              )}
          </Grid>
        );
      default:
        return null;
    }
  };

  if (isError) {
    return (
      <Typography color="error">
        Error fetching product details data. Please try again later.
      </Typography>
    );
  }

  const coursings: IVariantView[] = Array.isArray(
    productHistoryRecordData?.data
  )
    ? (productHistoryRecordData?.data as IVariantView[])
    : [];

  const storeItemsList: IOrderItemViewList2[] = Array.isArray(
    orderListRecordData?.data
  )
    ? (orderListRecordData?.data as IOrderItemViewList2[])
    : [];

  return (
    <Grid container spacing={3}>
      <Grid item lg={3} md={4} sm={12} xs={12}>
        <Card className={classes.stepperCard} sx={{ height: "100%" }}>
          <Grid container spacing={2} p={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid
                container
                justifyContent={"center"}
                spacing={2}
                sx={{ padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  display={isMobileRes ? "flex" : undefined}
                  alignContent={"center"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Box className={classes.productBox}>
                    {product?.variantImg || ReplaceImage ? (
                      <img
                        src={product?.variantImg || ReplaceImage}
                        alt="img"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "cover",
                          borderRadius: "6px",
                        }}
                        onError={(e) => (e.currentTarget.src = ReplaceImage)}
                      />
                    ) : (
                      <IoIosImages style={{ fontSize: 60 }} />
                    )}
                  </Box>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="h4" textAlign={"center"}>
                    {toProperCase(product?.variantName)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={2}
                sx={{ px: 2, pb: 3 }}
                className={classes.titleGrid}
              >
                <Grid item xs={12}>
                  <Stack spacing={1}>
                    <DetailRow
                      label="Name"
                      value={toProperCase(product?.variantName)}
                    />

                    {product?.variantDisplayName && (
                      <DetailRow
                        label="Display Name"
                        value={toProperCase(product.variantDisplayName)}
                      />
                    )}
                    {product?.variantRefNumber && (
                      <DetailRow
                        label="Reference No"
                        value={product.variantRefNumber}
                      />
                    )}

                    {product?.mainItemId && (
                      <DetailRow
                        label="Product"
                        value={
                          <Link
                            to={`/main/item/view/${product.mainItemId}`}
                            className={classes.iconLinkPropNormal}
                          >
                            {mainItenMap.get(product.mainItemId) || ""}
                          </Link>
                        }
                      />
                    )}

                    {product?.categoryId && (
                      <DetailRow
                        label="Category"
                        value={categoryMap.get(product.categoryId) || ""}
                      />
                    )}

                    {product?.variantBrandId && (
                      <DetailRow
                        label="Brand"
                        value={
                          productBrandMap.get(product.variantBrandId) || ""
                        }
                      />
                    )}

                    {product?.variantTagId &&
                      product?.variantTagId?.length > 0 && (
                        <DetailRow
                          label="Tags"
                          value={product.variantTagId
                            .map((id) => tagMap.get(id) || "")
                            .join(", ")}
                        />
                      )}

                    {product?.variantPrinterIds &&
                      product?.variantPrinterIds?.length > 0 && (
                        <DetailRow
                          label="Printers"
                          value={product.variantPrinterIds
                            .map((id) => printerMap.get(id) || "")
                            .join(", ")}
                        />
                      )}

                    {product?.variantUnit && (
                      <DetailRow
                        label="Conversion Unit"
                        value={convertUnit(product.variantUnit)}
                      />
                    )}

                    {product?.packCount && (
                      <DetailRow label="Pack Count" value={product.packCount} />
                    )}

                    {product?.size && (
                      <DetailRow
                        label="Size"
                        value={`${formatUnit(product.size)} ${convertUnit(product.sizeUnit)}`}
                      />
                    )}

                    {/* {product?.sizeUnit && (
                      <DetailRow
                        label="Size Conversion Unit"
                        value={convertUnit(product.sizeUnit)}
                      />
                    )} */}

                    {product?.orderNumber && (
                      <DetailRow
                        label="Order Number"
                        value={product.orderNumber}
                      />
                    )}

                    {product?.bgColor && (
                      <DetailRow
                        label="Button Color"
                        value={
                          <Chip
                            label=" "
                            sx={{
                              backgroundColor: product.bgColor,
                              width: 24,
                              height: 24,
                            }}
                          />
                        }
                      />
                    )}

                    {product?.created_by && (
                      <DetailRow
                        label="Created by"
                        value={userMap.get(product.created_by)}
                      />
                    )}

                    {product?.created_at && (
                      <DetailRow
                        label="Created at"
                        value={dayjs(product.created_at).format(
                          "MMM D, YYYY h:mm A"
                        )}
                      />
                    )}

                    {product?.updated_by && (
                      <DetailRow
                        label="Updated by"
                        value={userMap.get(product.updated_by)}
                      />
                    )}

                    {product?.updated_by && product?.updated_at && (
                      <DetailRow
                        label="Updated at"
                        value={dayjs(product.updated_at).format(
                          "MMM D, YYYY h:mm A"
                        )}
                      />
                    )}

                    {product?.variantShortDescription && (
                      <DetailRow
                        label="Short Description"
                        value={product.variantShortDescription}
                      />
                    )}

                    {product?.variantLongDescription && (
                      <DetailRow
                        label="Long Description"
                        value={product.variantLongDescription}
                      />
                    )}
                  </Stack>
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  {product && (
                    <Grid
                      container
                      spacing={1}
                      justifyContent="flex-end"
                      sx={{ display: "flex" }}
                    >
                      <Grid item>
                        <Button
                          // variant="contained"
                          className={classes.editButtonList}
                          onClick={() => handleOpenDialog(product)}
                        >
                          <EditSharpIcon className={classes.editListIcon} />
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          // variant="contained"
                          className={classes.deleteButtonList}
                          onClick={() => handleOpenDeletePopup(product)}
                        >
                          <DeleteOutlineSharpIcon
                            className={classes.deleteListIcon}
                          />
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item lg={9} md={8} sm={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <CompactStatusCard
                  label="Active"
                  status={!!product?.isActive}
                />
              </Grid>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <CompactStatusCard
                  label="Can Sell"
                  status={!!product?.isOnSale}
                />
              </Grid>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <CompactStatusCard
                  label="Display"
                  status={!!product?.isPosDisplay}
                />
              </Grid>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <CompactStatusCard
                  label="Looping"
                  status={!!product?.isLooping}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={2.5} md={4} sm={6} xs={12}>
                <Card
                  className={
                    activeSection === Section.Price
                      ? classes.selectedcardVariant
                      : classes.unselectedcardVariant
                  }
                  onClick={() => handleContainerChange(Section.Price)}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar
                      className={
                        activeSection === Section.Price
                          ? classes.selectedcardVariantAvart
                          : classes.unselectedcardVariantAvatar
                      }
                    >
                      <AttachMoneyIcon />
                    </Avatar>
                    <Typography fontWeight={600}>Price</Typography>
                  </Stack>
                </Card>
              </Grid>
              <Grid item lg={2.5} md={4} sm={6} xs={12}>
                <Card
                  className={
                    activeSection === Section.Order
                      ? classes.selectedcardVariant
                      : classes.unselectedcardVariant
                  }
                  onClick={() => handleContainerChange(Section.Order)}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar
                      className={
                        activeSection === Section.Order
                          ? classes.selectedcardVariantAvart
                          : classes.unselectedcardVariantAvatar
                      }
                    >
                      <ReorderIcon />
                    </Avatar>
                    <Typography fontWeight={600}>Order</Typography>
                  </Stack>
                </Card>
              </Grid>
              <Grid item lg={2.5} md={4} sm={6} xs={12}>
                <Card
                  className={
                    activeSection === Section.History
                      ? classes.selectedcardVariant
                      : classes.unselectedcardVariant
                  }
                  onClick={() => handleContainerChange(Section.History)}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar
                      className={
                        activeSection === Section.History
                          ? classes.selectedcardVariantAvart
                          : classes.unselectedcardVariantAvatar
                      }
                    >
                      <PlaylistAddCheckIcon />
                    </Avatar>
                    <Typography fontWeight={600}>History</Typography>
                  </Stack>
                </Card>
              </Grid>
            </Grid>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            {renderContent()}
          </Grid>
        </Grid>
      </Grid>

      {selectedProduct && (
        <NewPopUpProduct
          openModel={openDialogProduct}
          handleCloseDialog={handleCloseDialog}
          data={selectedProduct}
        />
      )}

      {selectedProduct2 && (
        <StorepriceOnly
          openModel={openDialogProduct2}
          handleCloseDialog={handleCloseDialog2}
          data={selectedProduct2}
        />
      )}
      {productToDelete && (
        <DeletePopup
          open={openDeleteProduct}
          handleCloseDelete={handleCloseDeletePopup}
          onConfirm={async () => {
            await handleDelete(productToDelete.id.toString());
          }}
          title="Delete Product"
          content={`Are you sure you want to delete "${productToDelete.variantName}"?`}
        />
      )}
    </Grid>
  );
};

export default Index;
